<template>
    <div class="Loadingscreen">
        <div class="ls-container">

            <!-- Default Loadingscreen -> GIF -->
            <video v-if="logoURL == './flux/fluxLogoGross.png'" class="ls-video" src="@/assets/loadingscreen.mp4" loop autoplay muted></video>

            <!-- Branded Loadingscreen -> Logo + Generic GIF-->
            <div v-else>
                <img class="ls-logo" :src="logoURL" alt="">
                <svg class="ls-animation" version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
                    <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                        <animateTransform attributeName="transform" attributeType="XML"  type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite" />
                    </path>
                </svg>
            </div>

            <!-- Progress Visualization -> %-Text-->
            <p class="ls-text">100%</p>     

        </div>          
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    data: () => ({
        firstTime: true,
    }),
    computed: {
        ...mapGetters(['logoURL']),
    },
    watch:{
        loadingscreenVisible(){
            this.firstTime = false;
        }
    },
    mounted: function(){
        document.getElementsByClassName("ls-container")[0].style.opacity = 1; 
    }
}
</script>

<style>
    .Loadingscreen{
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 100;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #FCFBFD;
    }
    .ls-container{
        opacity: 0;
        transition: 1s opacity ease-in;
    }
    .ls-video{        
        width: 500px;
    }
    .ls-logo{
        width: 350px;
        height: 350px;
    }
    .ls-animation{
        fill: var(--primaryColor);
        width: 200px;
        height: 200px;
        margin: auto;
        display: block;
    }
    .ls-text{
        position: relative;
        top: -30px;
        opacity: 0;
        font-size: 23px;
        text-align: center;
        margin: 0;
        transition: .2s opacity ease-in;
    }
    /*MOBILE*/
    @media (max-device-width: 900px){
        .ls-container{
            width: 250px;
        }
    }
</style>